import React, { ComponentType } from "react";
import { connect } from "react-redux";
import { IApplicationState } from "../../store";
import { selectAuth } from "../../store/auth/selectors";
import { userInRoles } from "./AuthorizeRoute";
import styled from "styled-components";

export interface IAuthorizedComponentProps {
  isAuthenticated: boolean;
  userRoles: string[];
  roles?: string[];
  allowUnauthorized?: boolean;
  children: React.ReactNode;
}

export interface IShowable {
  show?: string;
}

export function AuthorizedComponentHOC<TOriginalProps>(
  WrappedComponent: ComponentType<TOriginalProps>,
  roles?: string[],
  allowUnauthorized?: boolean,
): ComponentType<TOriginalProps> {
  const StyledWrappedComponent = styled(WrappedComponent)<{
    show: string | undefined;
  }>`
    ${props => !props.show && `display: none;`}
  `;

  // adding companyId here so that it get's pulled out of the props which are passed down to the component
  const result = ({ companyId, isAuthenticated, userRoles, ...props }: any) => {
    const show = (allowUnauthorized && !isAuthenticated) || (isAuthenticated && userInRoles(roles, userRoles));

    return <StyledWrappedComponent {...props} show={show ? "true" : undefined} />;
  };

  return connect((state: IApplicationState) => ({
    ...selectAuth(state),
  }))(result);
}

const AuthorizedComponent = (props: IAuthorizedComponentProps) => {
  const { isAuthenticated, roles, userRoles, allowUnauthorized, children } = props;

  if ((allowUnauthorized && !isAuthenticated) || (isAuthenticated && userInRoles(roles, userRoles))) {
    return <>{children}</>;
  }
  return null;
};

export default connect((state: IApplicationState) => ({
  ...selectAuth(state),
}))(AuthorizedComponent);
